<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-exam-modal-list">
      <h2>Mover produto</h2>
    </div>
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Quantidade a ser movida</mat-label>
            <input matInput type="number" formControlName="amount" min="1" [max]="this.storageAmountLocation.amountRemaining" oninput="validity.valid||(value=null);">
            @if (model.get('amount').invalid && !model.get('numberDrops')?.hasError('max')) {
              <mat-error>Quantidade inválida</mat-error>
            }
            @if (model.get('amountTotal')?.hasError('max')) {
              <mat-error>Valor máximo acima do
              permitido.</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Localização</mat-label>
            <mat-select formControlName="idLocation">
              @for (item of listLocation; track item) {
                <mat-option
                  [value]="item.idLocation">
                {{item.locationName}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>

<div mat-dialog-footer class="footer-modal">
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="submit" color="primary" class="btn-block" (click)="submit()">
        @if (isLoading == false) {
          <span>Salvar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class="btn-block" (click)="clickCancel()">
        @if (isLoading == false) {
          <span>Cancelar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>
